import BrandLogo from "@/components/BrandLogo";
import Button from "@/components/Button";
import Container from "@/components/Container";
import Page from "@/components/Page";
import { useNavigate } from "react-router-dom";

export default function AlreadyRegistered() {
  const navigate = useNavigate();

  return (
    <Container>
      <BrandLogo centered />

      <Page>
        <h1>Detta test är avsett för nya användare</h1>
        <p>
          Om du är intresserad av våra behandlingsformer, vänligen prata med din
          vårdgivare i Blodtrycksdoktorns app.
        </p>
        <p className="text-center">
          <Button onClick={() => navigate("/", { replace: true })}>Okej</Button>
        </p>
      </Page>
    </Container>
  );
}
